import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';

interface TitleProps {
  children: React.ReactNode;
  className?: string;
  subtitle?: string;
  animate?: boolean;
}

export function Title({ children, className, subtitle, animate = true }: TitleProps) {
  const HeadingComponent = animate ? motion.h1 : 'h1';
  const SubtitleComponent = animate ? motion.p : 'p';

  return (
    <div className={clsx('mb-12', className)}>
      <HeadingComponent
        initial={animate ? { opacity: 0, x: -20 } : undefined}
        animate={animate ? { opacity: 1, x: 0 } : undefined}
        transition={{ duration: 0.5 }}
        className="font-tilt-warp text-3xl md:text-4xl lg:text-5xl text-light mb-4"
      >
        {children}
      </HeadingComponent>
      {subtitle && (
        <SubtitleComponent
          initial={animate ? { opacity: 0, x: -20 } : undefined}
          animate={animate ? { opacity: 1, x: 0 } : undefined}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-base md:text-lg lg:text-xl text-light/60 max-w-2xl"
        >
          {subtitle}
        </SubtitleComponent>
      )}
    </div>
  );
}